import { Link } from 'react-router-dom';
import type { Movie } from '@/types/movie';
import { formatViews } from '@/utils/movie';

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}电影海报`}
          title={`${movie.title}高清电影海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-white">
          <i className="ri-star-fill text-xs"></i>
          {movie.rating.toFixed(1)}
        </span>
        {rank !== undefined && (
          <span className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-md bg-primary-500 font-label text-xs font-bold text-background-50">
            {rank}
          </span>
        )}
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/70 to-transparent"></div>
        <span className="absolute bottom-2 right-2 flex items-center gap-1 text-xs text-background-100">
          <i className="ri-eye-line text-xs"></i>
          {formatViews(movie.views)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="text-foreground-300">·</span>
          <span>{movie.region}</span>
        </p>
      </div>
    </Link>
  );
}